module.exports = __webpack_public_path__ + "static/img/128.0ea3c8d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/digital/news/128.png
// module id = VlZj
// module chunks = 0